<template>
  <div class="col-md-9 col-lg-10 ml-md-auto">
    {{statusAlert()}}
    <div v-if="error" class="validation py-3 px-5 my-4">
      <p class="m-0">{{ error }}</p>
    </div>
    <div class="edit-property-form mb-4">
      <b-container fluid class="p-0" v-if="propertyData">
        <div class="p-4 bg-light mb-3">
          <b-row>
            <b-col lg="2">
              <label class="font-weight-bold required">{{ $t('administrative_title') }}</label>
            </b-col>
            <b-col lg="10">
              <b-form-input v-model="$v.propertyData.administrative_title.$model" class="form-input" :state="validateState('administrative_title')"></b-form-input>
              <b-form-invalid-feedback :state="validateState('administrative_title')">
                <p v-if="!$v.propertyData.administrative_title.required">{{ $t('is required').replace('%s', $t('administrative_title')) }}</p>
                <p v-if="!$v.propertyData.administrative_title.maxLength">{{ $t('less than').replace('%s', $t('administrative_title')).replace('%d', $v.propertyData.administrative_title.$params.maxLength.max) }}</p>
                <p v-if="!$v.propertyData.administrative_title.minLength">{{ $t('more than').replace('%s', $t('administrative_title')).replace('%d', $v.propertyData.administrative_title.$params.minLength.min) }}</p>
              </b-form-invalid-feedback>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="2">
              <label>{{ $t('property_category') }}</label>
            </b-col>
            <b-col lg="4">
              <b-form-select v-model="propertyData.property_category" :options="property_type" class="form-select"></b-form-select>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="2">
              <label>{{ $t('label_sales-status') }}</label>
            </b-col>
            <b-col lg="4">
              <b-form-select v-model="propertyData.report_status" :options="newStatus" class="form-select"></b-form-select>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="2">
              <label>{{ $t('prefecture') }}</label>
            </b-col>
            <b-col lg="4">
                <b-form-select v-model="propertyData.prefecture" :options="prefecture" class="form-select"></b-form-select>
            </b-col>
          </b-row>
        </div>
        <div class="accordion" role="tablist" v-for="(propertyValues, key) in propertyData.property" :key="propertyValues.id">
          <b-card no-body>
            <b-card-header class="d-flex align-items-center justify-content-between bg-secondary text-white" role="tab">
              <h4 v-b-toggle="key" class="mb-0">
                {{ key }}
                <span class="h-100 ml-3"><b-icon icon="pencil-fill" scale="1" v-show="propertyData.property_types[propertyValues.language] !== 'published' && propertyValues.property_name !== null"></b-icon></span>
              </h4>
              <div class="d-flex align-items-center">
                <label class="m-0 h-100 d-flex align-items-center px-4 label-check">
                  <b-form-checkbox size="lg" :checked="propertyData.property_types[propertyValues.language] === 'published' ? true: false" @change="selectLanguage(key, $event)"></b-form-checkbox>
                  {{ $t('label_publish') }}
                </label>
                <button v-b-toggle="key" block class="bg-transparent border-0 mr-0 w-auto h-100 px-4" :class="{ 'not-collapsed': toggleOpen, 'text-white': true }" @click="toggleOpen = !toggleOpen">
                  <span class="h-100 align-items-center d-flex icon"><b-icon icon="chevron-down" scale="1.5"></b-icon></span>
                </button>
              </div>
            </b-card-header>
            <b-collapse :id="key" :visible="propertyValues.language === $route.params.language" accordion="my-accordion" role="tabpanel">
              <b-card-body class="text-dark bg-light">
                <b-row>
                  <b-col lg="2">
                    <label class="m-0 required">{{ $t('property_name') }}</label>
                  </b-col>
                  <b-col lg="10">
                    <b-form-input class="form-input" @input="statusDraft($event, key)" v-model="propertyValues.property_name"></b-form-input>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="2">
                    <label class="m-0">{{ $t('property_price') }}</label>
                  </b-col>
                  <b-col lg="4">
                    <div class="align-items-center d-flex">
                      <currency-input
                          :currency="null"
                          locale="ja"
                          :valueAsInteger="true"
                          :precision="0"
                          :value="Number(propertyValues.property_price)"
                          class="form-input form-control"
                          :allowNegative="false"
                          @keyup="currencyUpdate(key, $event, 'property_price')"
                      />
                      <span class="span ml-2">{{ $t('yen') }}</span>
                    </div>
                  </b-col>
                  <b-col lg="2">
                    <label class="m-0">{{ $t('building_price') }}</label>
                  </b-col>
                  <b-col lg="4">
                    <div class="align-items-center d-flex">
                      <currency-input
                          :currency="null"
                          locale="ja"
                          :valueAsInteger="true"
                          :precision="0"
                          :value="Number(propertyValues.building_price)"
                          class="form-input form-control"
                          :allowNegative="false"
                          @keyup="currencyUpdate(key, $event, 'building_price')"
                      />
                      <span class="span ml-2">{{ $t('yen') }}</span>
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="2">
                    <label class="m-0">{{ $t('land_price') }}</label>
                  </b-col>
                  <b-col lg="4" class="align-items-center d-flex">
                    <currency-input
                      :currency="null"
                      locale="ja"
                      :valueAsInteger="true"
                      :precision="0"
                      :value="Number(propertyValues.land_price)"
                      class="form-input form-control"
                      :allowNegative="false"
                      @keyup="currencyUpdate(key, $event, 'land_price')"
                      />
                      <span class="span ml-2">{{ $t('yen') }}</span>
                  </b-col>
                  <b-col lg="2">
                    <label class="m-0">{{ $t('yields') }}</label>
                  </b-col>
                  <b-col lg="4" class="align-items-center d-flex">
                    <b-form-input v-model="propertyValues.yields" class="form-input"></b-form-input>
                    <span class="ml-2">%</span>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="2">
                    <label class="m-0">{{ $t('estimated_annual_income') }}</label>
                  </b-col>
                  <b-col lg="4" class="align-items-center d-flex">
                    <currency-input
                      :currency="null"
                      locale="ja"
                      :valueAsInteger="true"
                      :precision="0"
                      :value="Number(propertyValues.estimated_annual_income)"
                      class="form-input form-control"
                      :allowNegative="false"
                      @keyup="currencyUpdate(key, $event, 'estimated_annual_income')"
                      />
                      <span class="span ml-2">{{ $t('yen') }}</span>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="2" class="d-flex">
                    <label class="m-0">{{ $t('copy') }}</label>
                  </b-col>
                  <b-col lg="10">
                    <b-form-textarea class="form-input" v-model="propertyValues.copy" rows="6">
                    </b-form-textarea>
                  </b-col>
                </b-row>
                <!-- メイン画像 ここから -->
                <template v-if="propertyValues.properties_images === null">
                  <b-row>
                    <b-col lg="2">
                      <label class="m-0">{{ $t('main_image') }}</label>
                    </b-col>
                    <b-col lg="10">
                      <b-form-file required @change="uploadImage($event, key, 'mainImageNew')" accept=".jpg, .png, .gif" :placeholder="$t('label_choose-file')"></b-form-file>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col lg="2">{{ $t('main_image_caption') }}</b-col>
                    <b-col lg="10">
                      <b-form-input class="form-input" v-model="imagesMain[key].label"></b-form-input>
                    </b-col>
                  </b-row>
                </template>
                <template v-else>
                  <div v-for="mainImage in propertyValues.properties_images.filter(i => i.index === String(0) && i.type === 'mainImage')" :key="mainImage.id">
                    <b-row>
                      <b-col lg="2">
                        <label class="m-0">{{ $t('main_image') }}</label>
                      </b-col>
                      <b-col lg="10">
                        <b-form-file :required="imageUrl(propertyValues.properties_images)" @change="uploadImage($event, key, 'mainImage')" accept=".jpg, .png, .gif" :placeholder="mainImage.images.url === '' ? $t('label_choose-file') : mainImage.images.url"></b-form-file>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col lg="2">{{ $t('main_image_caption') }}</b-col>
                      <b-col>
                        <b-form-input v-model="mainImage.label" class="form-input"></b-form-input>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col lg="10" class="ml-auto image-box">
                        <img :src="decodeURI(mainImage.images.url)" v-if="mainImage.images.url.startsWith('http')">
                      </b-col>
                    </b-row>
                  </div>
                </template>
                <!-- メイン画像 ここまで-->
                <!-- サブ画像 ここから -->
                <div v-for="(subImage, index) in subImages(propertyValues)" :key="subImage.id">
                  <b-row>
                    <b-col lg="2">
                      <label class="m-0">{{ $t('sub_image') }}{{ index + 1 }}</label>
                    </b-col>
                    <b-col lg="10" class="d-flex">
                      <b-form-file @change="uploadImageSub($event, key, 'subImage', index + 1)" accept=".jpg, .png, .gif" :placeholder="subImage.images.url"></b-form-file>
                      <span class="btn btn-danger ml-2" @click="deleteImageExists(propertyData, subImage, propertyValues.properties_images)"><b-icon icon="dash" scale="2"></b-icon></span>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col lg="2">{{ $t('sub_image_caption') }}{{ index + 1 }}</b-col>
                    <b-col lg="10">
                      <b-form-input v-model="subImage.label" class="form-input"></b-form-input>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col lg="10" class="d-flex align-items-center ml-auto my-2 image-box">
                      <img :src="decodeURI(subImage.images.url)" v-if="subImage.images.url.startsWith('http')">
                    </b-col>
                  </b-row>
                </div>
                <div v-for="(items, idx) in imagesDefault[0][key]" :key="items.id">
                  <b-row>
                    <b-col lg="2">{{ $t('sub_image') }}{{ subImages(propertyValues).length + idx + 1 }}</b-col>
                    <b-col lg="10" class="d-flex align-items-center ml-auto">
                      <b-form-file required @change="uploadImageSubNew($event, key, idx, 'subImage')" accept=".jpg, .png, .gif" :placeholder="$t('label_choose-file')"></b-form-file>
                      <span v-if="imagesDefault[0][key].length !== 1" class="btn btn-danger ml-2" @click="deleteImageDynamics(key, idx)" ><b-icon icon="dash" scale="2"></b-icon></span>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col lg="2">{{ $t('sub_image_caption') }}{{ subImages(propertyValues).length + idx + 1 }}</b-col>
                    <b-col lg="10" class="d-flex align-items-center ml-auto">
                      <b-form-input v-model="items.label" class="form-input"></b-form-input>
                    </b-col>
                  </b-row>
                </div>
                <b-row>
                  <b-col lg="10" class="ml-auto">
                    <span class="btn btn-primary btn-block" @click="addImages(key)"><b-icon icon="plus" scale="2"></b-icon></span>
                  </b-col>
                </b-row>
                <!-- サブ画像 ここまで -->
                <b-row>
                  <b-col lg="2">
                    <label class="m-0">{{ $t('movie_url') }}</label>
                  </b-col>
                  <b-col lg="10">
                    <template v-if="propertyValues.property_video !== null">
                      <b-form-input v-model="propertyValues.property_video[0].videos[0].url" class="form-input" @input="validateVideo($event, key)" :state="validateStateVideo(key)"></b-form-input>
                      <small class="form-text text-muted">{{ $t('description-movie_url') }}</small>
                    </template>
                    <template v-else>
                      <b-form-input v-model="$v.videos.$each[0][key].$model" class="form-input" @input="validateVideo($event, key)" :state="validateStateNewVideo(key)"></b-form-input>
                      <small class="form-text text-muted">{{ $t('description-movie_url') }}</small>
                      <b-form-invalid-feedback :state="validateStateNewVideo(key)">
                        <p v-if="!$v.videos.$each[0][key].url">{{ $t('invalid', [$t('movie_url')]) }}</p>
                      </b-form-invalid-feedback>
                    </template>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="2">
                    <label class="m-0">{{ $t('street_address') }}</label>
                  </b-col>
                  <b-col lg="10">
                    <b-form-input class="form-input" v-model="propertyValues.street_address"></b-form-input>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="2" class="d-flex">
                    <label class="m-0">{{ $t('nearest_station') }}</label>
                  </b-col>
                  <b-col lg="10">
                    <b-form-textarea class="form-input" v-model="propertyValues.nearest_station" rows="6" ></b-form-textarea>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="2">
                    <label class="m-0">{{ $t('building_area') }}</label>
                  </b-col>
                  <b-col lg="4" class="align-items-center d-flex">
                    <b-form-input class="form-input" v-model="propertyValues.building_area" ></b-form-input>
                    <span class="ml-2">㎡</span>
                  </b-col>
                  <b-col lg="2">
                    <label class="m-0">{{ $t('land_area') }}</label>
                  </b-col>
                  <b-col lg="4" class="align-items-center d-flex">
                    <b-form-input class="form-input" v-model="propertyValues.land_area" ></b-form-input>
                    <span class="ml-2">㎡</span>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="2">
                    <label class="m-0">{{ $t('date_of_construction') }}</label>
                  </b-col>
                  <b-col lg="4" class="align-items-center d-flex">
                    <b-form-input class="form-input" v-model="propertyValues.date_of_construction" ></b-form-input>
                  </b-col>
                  <b-col lg="2">
                    <label class="m-0">{{ $t('floor') }}</label>
                  </b-col>
                  <b-col lg="4" class="align-items-center d-flex">
                    <b-form-input type="text" v-model="propertyValues.floor" class="form-input"></b-form-input>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="2">
                    <label class="m-0">{{ $t('construction') }}</label>
                  </b-col>
                  <b-col lg="4" class="align-items-center d-flex">
                    <b-form-input type="text" v-model="propertyValues.construction" class="form-input"></b-form-input>
                  </b-col>
                  <b-col lg="2">
                    <label class="m-0">{{ $t('unit_price') }}</label>
                  </b-col>
                  <b-col lg="4">
                    <b-form-input v-model="propertyValues.unit_price" class="form-input"></b-form-input>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="2">
                    <label class="m-0">{{ $t('total_unit') }}</label>
                  </b-col>
                  <b-col lg="4" class="align-items-center d-flex">
                    <b-form-input v-model="propertyValues.total_unit" class="form-input"></b-form-input>
                  </b-col>
                  <b-col lg="2">
                    <label class="m-0">{{ $t('number_of_unit_sold') }}</label>
                  </b-col>
                  <b-col lg="4">
                    <b-form-input v-model="propertyValues.number_of_unit_sold" class="form-input"></b-form-input>
                  </b-col>
                  </b-row>
                  <b-row>
                  <b-col lg="2">
                    <label class="m-0">{{ $t('building_coverage_ratio') }}</label>
                  </b-col>
                  <b-col lg="4" class="align-items-center d-flex">
                    <b-form-input class="form-input" v-model="propertyValues.building_coverage_ratio" ></b-form-input>
                    <span class="ml-2">%</span>
                  </b-col>
                  <b-col lg="2">
                    <label class="m-0">{{ $t('floor_area_ratio') }}</label>
                  </b-col>
                  <b-col lg="4" class="align-items-center d-flex">
                    <b-form-input class="form-input" v-model="propertyValues.floor_area_ratio"></b-form-input>
                    <span class="ml-2">%</span>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="2">
                    <label class="m-0">{{ $t('setback') }}</label>
                  </b-col>
                  <b-col lg="4" class="align-items-center d-flex">
                    <b-form-input class="form-input" v-model="propertyValues.setback"></b-form-input>
                  </b-col>
                  <b-col lg="2">
                    <label class="m-0">{{ $t('floor_plan_type') }}</label>
                  </b-col>
                  <b-col lg="4" class="align-items-center d-flex">
                    <b-form-input class="form-input" v-model="propertyValues.floor_plan_type"></b-form-input>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="2">
                    <label class="m-0">{{ $t('floor_plan_details') }}</label>
                  </b-col>
                  <b-col lg="4" class="align-items-center d-flex">
                    <b-form-input class="form-input" v-model="propertyValues.floor_plan_details"></b-form-input>
                  </b-col>
                  <b-col lg="2">
                    <label class="m-0">{{ $t('facility') }}</label>
                  </b-col>
                  <b-col lg="4" class="align-items-center d-flex">
                    <b-form-input class="form-input" v-model="propertyValues.facility"></b-form-input>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="2">
                    <label class="m-0">{{ $t('current_situation') }}</label>
                  </b-col>
                  <b-col lg="4" class="align-items-center d-flex">
                    <b-form-input class="form-input" v-model="propertyValues.current_situation"></b-form-input>
                  </b-col>
                  <b-col lg="2">
                    <label class="m-0">{{ $t('land_rights') }}</label>
                  </b-col>
                  <b-col lg="4" class="align-items-center d-flex">
                    <b-form-input class="form-input" v-model="propertyValues.land_rights"></b-form-input>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="2">
                    <label class="m-0">{{ $t('ground') }}</label>
                  </b-col>
                  <b-col lg="4">
                    <b-form-input type="text" v-model="propertyValues.ground" class="form-input"></b-form-input>
                  </b-col>
                  <b-col lg="2">
                    <label class="m-0">{{ $t('area_of_use') }}</label>
                  </b-col>
                  <b-col lg="4" class="align-items-center d-flex">
                    <b-form-input type="text" v-model="propertyValues.area_of_use" class="form-input"></b-form-input>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="2">
                    <label class="m-0">{{ $t('city_planning') }}</label>
                  </b-col>
                  <b-col lg="4" class="align-items-center d-flex">
                    <b-form-input type="text" v-model="propertyValues.city_planning" class="form-input"></b-form-input>
                  </b-col>
                  <b-col lg="2">
                    <label class="m-0">{{ $t('parking_lot') }}</label>
                  </b-col>
                  <b-col lg="4" class="align-items-center d-flex">
                    <b-form-input class="form-input" v-model="propertyValues.parking_lot"></b-form-input>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="2">
                    <label class="m-0">{{ $t('roadside_situation') }}</label>
                  </b-col>
                  <b-col lg="4" class="align-items-center d-flex">
                    <b-form-input class="form-input" v-model="propertyValues.roadside_situation"></b-form-input>
                  </b-col>
                  <b-col lg="2">
                    <label class="m-0">{{ $t('driveway_burden') }}</label>
                  </b-col>
                  <b-col lg="4" class="align-items-center d-flex">
                    <b-form-input class="form-input" v-model="propertyValues.driveway_burden"></b-form-input>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="2">
                    <label class="m-0">{{ $t('main_lighting_surface') }}</label>
                  </b-col>
                  <b-col lg="4" class="align-items-center d-flex">
                    <b-form-input class="form-input" v-model="propertyValues.main_lighting_surface"></b-form-input>
                  </b-col>
                  <b-col lg="2">
                    <label class="m-0">{{ $t('delivery_date') }}</label>
                  </b-col>
                  <b-col lg="4" class="align-items-center d-flex">
                    <b-form-input class="form-input" v-model="propertyValues.delivery_date"></b-form-input>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="2">
                    <label class="m-0">{{ $t('transaction_mode') }}</label>
                  </b-col>
                  <b-col lg="4">
                    <b-form-input type="text" v-model="propertyValues.transaction_mode" class="form-input"></b-form-input>
                  </b-col>
                  <b-col lg="2">
                    <label class="m-0">{{ $t('information_disclousure_date') }}</label>
                  </b-col>
                  <b-col lg="4" class="align-items-center d-flex">
                    <b-form-datepicker v-model="propertyValues.information_disclousure_date" :placeholder="$t('label_choose-date')"></b-form-datepicker>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="2">
                    <label class="m-0">{{ $t('inspection_certificate') }}</label>
                  </b-col>
                  <b-col lg="4">
                    <b-form-input type="text" v-model="propertyValues.inspection_certificate" class="form-input"></b-form-input>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="2">
                    <label class="m-0">{{ $t('remarks') }}</label>
                  </b-col>
                  <b-col lg="10" class="align-items-center d-flex">
                    <b-form-input class="form-input" v-model="propertyValues.remarks"></b-form-input>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="2">
                    <label class="m-0">{{ $t('google_map_html') }}</label>
                  </b-col>
                  <b-col lg="10">
                    <b-form-textarea type="text" class="form-input" @input="validationMap($event, key)"></b-form-textarea>
                    <small class="form-text text-muted">{{ $t('description-google_map_html') }}</small>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="2">
                    <label class="m-0">{{ $t('google_map_url') }}</label>
                  </b-col>
                  <b-col lg="10">
                    <b-form-input type="text" class="form-input" v-model="propertyValues.google_map_url"></b-form-input>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="2">
                    <label class="m-0">{{ $t('chatbot_url') }}</label>
                  </b-col>
                  <b-col lg="10">
                    <b-form-input type="text" v-model="$v.propertyData.property[key].chatbot_url.$model" class="form-input" :state="validateStateChat(key)"></b-form-input>
                    <b-form-invalid-feedback :state="validateStateChat(key)">
                    <p v-if="!$v.propertyData.property[key].chatbot_url.url">{{ $t('invalid', [$t('chatbot_url')]) }}</p>
                    </b-form-invalid-feedback>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-collapse>
          </b-card>
        </div>
      </b-container>
    </div>
    <div class="d-flex justify-content-between align-items-center mb-4">
      <a href="#scroll" class="text-white text-decoration-none" v-smooth-scroll><b-button class="py-3 px-5" variant="primary" @click="updatePropertyData" :disabled="disableUpdateButton">{{ $t('label_save') }}</b-button></a>
      <b-button class="py-3 px-5" variant="danger" @click="showModal">{{ $t('label_delete') }}</b-button>
    </div>
    <modal name="confirm-delete" height="auto" :reset="true">
      <div class="modal-body">
        <p>{{ $t('label_confirm-delete') }}</p>
        <div class="buttons">
          <b-button class="py-3 px-5 mr-3" variant="primary" @click="hideModal">{{ $t('cancel') }}</b-button>
          <b-button class="py-3 px-5" variant="danger" v-b-modal.modal-delete @click="delete_property">{{ $t('label_delete') }}</b-button>
        </div>
      </div>
    </modal>
  </div>
</template>
<script>
import { required, minLength, maxLength, url } from 'vuelidate/lib/validators'
import { mapActions, mapState } from 'vuex'
import { prefectures, businessPropertyValues } from '../../../assets/data/values'

export default {
  props: {
    apiType: {
      validator: function (value) {
        return ['member', 'admin'].indexOf(value) !== -1
      },
      default: 'admin'
    },
    reachedLimit: {
      type: Boolean,
      default: false
    },
    allUnpublished: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      toggleOpen: false,
      subImage: {
        日本語: [],
        英語: [],
        簡体字: [],
        繁体字: []
      },
      mainImage: {
        日本語: null,
        英語: null,
        簡体字: null,
        繁体字: null
      },
      imagesDefault: [{
        日本語: [{ url: '', label: '' }],
        英語: [{ url: '', label: '' }],
        簡体字: [{ url: '', label: '' }],
        繁体字: [{ url: '', label: '' }]
      }],
      imagesMain: {
        日本語: { url: '', label: '' },
        英語: { url: '', label: '' },
        簡体字: { url: '', label: '' },
        繁体字: { url: '', label: '' }
      },
      videos: [{
        日本語: null,
        英語: null,
        簡体字: null,
        繁体字: null
      }],
      en_lang: false,
      ja_lang: false,
      tw_lang: false,
      cn_lang: false,
      status: [],
      error: null,
      categories: 'a',
      property: 'a',
      imgDelete: [],
      sight: 'a',
      newStatus: [{ text: this.$i18n.t('please_choose') }].concat(businessPropertyValues.reportStatus.map(s => { return { value: s, text: this.$i18n.t(s) } })),
      property_type: Object.values(businessPropertyValues.propertyTypes).flat().map(t => { return { value: t, text: this.$i18n.t(t) } }),
      prefecture: prefectures.map(p => { return { value: p, text: this.$i18n.t(p.charAt(0).toUpperCase() + p.slice(1)) } })
    }
  },
  validations: {
    propertyData: {
      administrative_title: {
        required,
        minLength: minLength(5),
        maxLength: maxLength(100)
      },
      prefecture: { required },
      property: {
        日本語: {
          chatbot_url: { url },
          property_video: { $each: { videos: { $each: { url: { url } } } } }
        },
        英語: {
          chatbot_url: { url },
          property_video: { $each: { videos: { $each: { url: { url } } } } }
        },
        簡体字: {
          chatbot_url: { url },
          property_video: { $each: { videos: { $each: { url: { url } } } } }
        },
        繁体字: {
          chatbot_url: { url },
          property_video: { $each: { videos: { $each: { url: { url } } } } }
        }
      }
    },
    videos: {
      $each: {
        日本語: { url },
        英語: { url },
        簡体字: { url },
        繁体字: { url }
      }
    }
  },
  created () {
    this.getProperty({
      propertyId: this.$route.params.id,
      apiType: this.apiType
    })
    this.activeLanguage()
  },
  computed: {
    ...mapState('adminProperty', ['propertyData']),
    ...mapState(['apiStatus']),
    disableUpdateButton: function () {
      if (!this.propertyData) { return true }

      // 掲載上限に達していて、画面を開いた時点で全てが公開なら、ボタンをdisabledにする
      return this.reachedLimit && this.allUnpublished
    }
  },
  methods: {
    ...mapActions('adminProperty', ['getProperty', 'deleteProperty', 'deleteImage', 'updateProperty', 'statusPageList', 'updateImageViaFile']),
    validateState (name) {
      const { $dirty, $error } = this.$v.propertyData[name]
      return $dirty ? !$error : null
    },
    validateStateChat (key) {
      const { $dirty, $error } = this.$v.propertyData.property[key].chatbot_url
      return $dirty ? !$error : null
    },
    validateStateVideo (key) {
      const { $dirty, $error } = this.$v.propertyData.property[key].property_video
      return $dirty ? !$error : null
    },
    validateStateNewVideo (key) {
      const { $dirty, $error } = this.$v.videos.$each.$iter[0][key]
      return $dirty ? !$error : null
    },
    validateVideo ($event, key) {
      let mainVideo = ''
      const find = $event.search('https://vimeo.com/')
      if (find >= 0) {
        let vimeo = $event.split('https://vimeo.com/')
        vimeo = 'https://player.vimeo.com/video/' + vimeo[1]
        if (this.propertyData.property[key].property_video !== null) {
          this.propertyData.property[key].property_video[0].videos[0].url = vimeo
        } else {
          this.videos[0][key] = vimeo
        }
      } else {
        mainVideo = $event.split('watch?v=')
        if (mainVideo[1] !== undefined) {
          mainVideo = mainVideo[0] + 'embed/' + mainVideo[1]
          if (this.propertyData.property[key].property_video !== null) {
            this.propertyData.property[key].property_video[0].videos[0].url = mainVideo
          } else {
            this.videos[0][key] = mainVideo
          }
        }
      }
    },
    validationMap ($event, key) {
      if ($event === null) {
        return
      }

      const result = $event.match(/src="([^"]+)"/)
      if (!result) {
        return
      }
      this.propertyData.property[key].google_map_url = result[1]
    },
    onSubmit (event) {
      // サーバに送信する画像情報の先頭にメイン画像情報を言語ごとに挿入する
      this.imagesDefault.forEach(element => {
        for (var key in element) {
          this.imagesDefault[0][key].unshift(this.imagesMain[key])
        }
      })
      const dataValue = { dataValue: { property: this.propertyData, videos: this.videos, imageDefault: this.imagesDefault }, mainImageFile: this.mainImage, subImageFile: this.subImage }
      this.updateProperty({ data: dataValue, apiType: this.apiType })
      this.clearImages()
    },
    currencyUpdate (key, event, location) {
      this.propertyData.property[key][location] = event.target.value
    },
    uploadImage: function (event, key, status) {
      if (event.target.files.length === 0) return

      if (status !== 'mainImageNew') {
        this.mainImage[key] = event.target.files[0]
        const updateImage = this.mainImage[key].name
        let data = []
        data = { updateImage: updateImage, key: key, status: status }
        this.updateImageViaFile(data)
      } else {
        const nameImage = event.target.files[0].name
        this.mainImage[key] = event.target.files[0]
        this.imagesMain[key].url = nameImage
      }
    },
    uploadImageSub: function (event, key, status, index) {
      if (event.target.files.length === 0) return

      const nameImage = event.target.files[0].name
      this.subImage[key].push({ type: 'exist', index: index, file: event.target.files[0] })
      const updateImage = nameImage
      let data = []
      data = { updateImage: updateImage, key: key, status: status, index: index }
      this.updateImageViaFile(data)
    },
    uploadImageSubNew: function (event, key, keys, status) {
      if (event.target.files.length === 0) return

      const nameImage = event.target.files[0].name
      this.subImage[key].push({ type: 'new', index: this.subImage[key].length, file: event.target.files[0] })
      this.imagesDefault[0][key][keys].url = nameImage
    },
    updatePropertyData: function () {
      if (this.$v.$invalid) {
        this.error = this.$i18n.t('label_form-error')
      } else {
        this.imagesDefault.forEach(element => {
          for (var key in element) {
            this.imagesDefault[0][key].unshift(this.imagesMain[key])
          }
        })
        const values = this.propertyData.property
        const mustNotEmpty = []
        for (var key in values) {
          if (values[key].property_name !== null) {
            if (values[key].property_name.length === 0) {
              mustNotEmpty.push(true)
            }
          }
        }
        if (mustNotEmpty.length < 1) {
          this.propertyData.deletedImages = this.imgDelete
          const dataValue = { dataValue: { property: this.propertyData, videos: this.videos, imageDefault: this.imagesDefault }, mainImageFile: this.mainImage, subImageFile: this.subImage }
          this.updateProperty({ data: dataValue, apiType: this.apiType })
          this.error = null
        } else {
          this.error = this.$i18n.t('label_form-error')
        }
        this.clearImages()
        this.$nextTick(() => {
          this.$v.$reset()
        })
        this.error = null
      }
    },
    activeLanguage: function () {
      switch (this.$route.params.language) {
        case 'ja':
          return (this.ja_lang = true)
        case 'en':
          return (this.en_lang = true)
        case 'tw':
          return (this.tw_lang = true)
        case 'cn':
          return (this.cn_lang = true)
      }
    },
    delete_property: function () {
      this.deleteProperty({ data: this.$route.params.id, apiType: this.apiType })
    },
    showModal () {
      this.$modal.show('confirm-delete')
    },
    hideModal () {
      this.$modal.hide('confirm-delete')
    },
    addImages: function (key) {
      this.imagesDefault[0][key].push({ url: '', label: '' })
    },
    deleteImageExists: function (localizedProperty, image, images) {
      this.imgDelete.push(image.image_id)
      localizedProperty.deletedImages = this.imgDelete

      this.$delete(images, images.findIndex(i => i.image_id === image.image_id))
    },
    statusDraft: function (event, keys) {
      const languageTypes = this.propertyData.property_types
      switch (keys) {
        case '日本語':
          if (event.length > 0 && languageTypes.name_ja !== 'published') {
            this.status = { status: 'draft', language: 'name_ja' }
          }
          break
        case '英語':
          if (event.length > 0 && languageTypes.name_en !== 'published') {
            this.status = { status: 'draft', language: 'name_en' }
          }
          break
        case '簡体字':
          if (event.length > 0 && languageTypes['name_zh-cn'] !== 'published') {
            this.status = { status: 'draft', language: 'name_zh-cn' }
          }
          break
        case '繁体字':
          if (event.length > 0 && languageTypes['name_zh-tw'] !== 'published') {
            this.status = { status: 'draft', language: 'name_zh-tw' }
          }
          break
        default:
          break
      }
      this.statusPageList(this.status)
    },
    selectLanguage: function (keys, e) {
      switch (keys) {
        case '日本語':
          if (e === true) {
            this.status = { status: 'published', language: 'name_ja' }
          } else {
            this.status = { status: 'draft', language: 'name_ja' }
          }
          break
        case '英語':
          if (e === true) {
            this.status = { status: 'published', language: 'name_en' }
          } else {
            this.status = { status: 'draft', language: 'name_en' }
          }
          break
        case '簡体字':
          if (e === true) {
            this.status = { status: 'published', language: 'name_zh-cn' }
          } else {
            this.status = { status: 'draft', language: 'name_zh-cn' }
          }
          break
        case '繁体字':
          if (e === true) {
            this.status = { status: 'published', language: 'name_zh-tw' }
          } else {
            this.status = { status: 'draft', language: 'name_zh-tw' }
          }
          break
        default:
          break
      }
      this.statusPageList(this.status)
    },
    deleteImageDynamics: function (lang, key) {
      if (this.imagesDefault[0][lang].length > 1) {
        this.imagesDefault[0][lang].splice(key, 1)
        this.subImage[lang].splice(key, 1)
      }
    },
    statusAlert (append = false) {
      if (this.apiStatus !== null) {
        this.$bvToast.toast('body', {
          title: this.apiStatus,
          toaster: 'b-toaster-top-center',
          solid: true,
          appendToast: append,
          autoHideDelay: 3000
        })
      }
    },
    imageUrl: function (imageurl) {
      if (imageurl[0].images.url !== '') {
        return false
      } else {
        return true
      }
    },
    subImages: function (localizedProperty) {
      return (localizedProperty.properties_images !== null ? localizedProperty.properties_images : []).filter(i => i.index !== String(0))
    },
    clearImages: function () {
      this.imagesDefault = [{
        日本語: [{ url: '', label: '' }],
        英語: [{ url: '', label: '' }],
        簡体字: [{ url: '', label: '' }],
        繁体字: [{ url: '', label: '' }]
      }]
    }
  }
}
</script>
<style scoped>
.image-box img {
  width: 200px;
}
.bg-light .row,
.card-body .row {
  margin-bottom: .8rem;
  align-items: center;
}
.bg-light > .row:last-child,
.card-body > .row:last-child {
  margin-bottom: 0;
}
</style>
